import Link from 'next/link';
import styles from './TestEds.module.scss';

export const PluginSetupLinux = () => {
    return (
        <div className={styles.container}>
            <div className={styles.panel}>
                <h1>
                    Установка и настройка КриптоПРО ЭЦП Browser Plug-In в Linux
                </h1>
                <p>
                    Описание процесса установки приведено на примере
                    дистрибутива семейства Debian (x64).
                    <br />
                    Некоторые команды могут потребовать запуска с{' '}
                    <code>sudo</code>.<br />
                    Названия файлов и директорий могут отличаться из-за различий
                    в версиях.
                </p>
                <p>
                    Загрузите
                    <a
                        href="https://www.cryptopro.ru/products/cades/plugin"
                        rel="nofollow noopener noreferrer"
                        target="_blank"
                    >
                        {' КриптоПро ЭЦП Browser plug-in '}
                    </a>
                    <mark>версии 2.0</mark> и распакуйте его:
                </p>
                <pre>
                    <strong>
                        mkdir cades_linux_amd64 &amp;&amp; tar -xzvf
                        cades_linux_amd64.tar.gz -C cades_linux_amd64
                    </strong>
                </pre>
                <br />

                <p>
                    Сконвертируйте <code>rpm</code> в <code>deb</code>
                    пакеты при помощи утилиты <code>alien</code>:
                </p>
                <pre>
                    <strong>
                        apt-get install alien cd cades_linux_amd64 sudo alien
                        --scripts *
                    </strong>
                </pre>
                <br />

                <p>Установите пакеты:</p>
                <pre>
                    <strong>
                        sudo dpkg -i cprocsp-pki-cades_2.0.0-2_amd64.deb
                    </strong>
                    <br />
                    <strong>
                        sudo dpkg -i cprocsp-pki-plugin_2.0.0-2_amd64.deb
                    </strong>
                </pre>
                <br />

                <p>Проверьте наличие файлов плагина:</p>
                <pre>
                    <strong>
                        ls -la /opt/cprocsp/lib/amd64 | grep libnpcades
                    </strong>
                    <br />
                    <code>
                        lrwxrwxrwx 1 root root 19 Окт 21 12:33{' '}
                        <mark>libnpcades.so -&gt; libnpcades.so.2.0.0</mark>
                        <br />
                        lrwxrwxrwx 1 root root 19 Окт 21 12:33{' '}
                        <mark>libnpcades.so.2 -&gt; libnpcades.so.2.0.0</mark>
                        <br />
                        -rwxr-xr-x 1 root root 2727236 Июн 8 14:33{' '}
                        <mark>libnpcades.so.2.0.0</mark>
                    </code>
                </pre>
                <br />

                <p>
                    Для использования Firefox версий ниже 52 необходимо
                    скопировать файлы плагина и убедиться в отсутствии битых
                    ссылок на библиотеки:
                </p>

                <pre>
                    <strong>
                        cd /usr/lib/mozilla/plugins
                        <br />
                        sudo cp /opt/cprocsp/lib/amd64/libnpcades.so.2.0.0 ./
                        <br />
                        ldd libnpcades.so.2.0.0
                        <br />
                        <br />
                        sudo cp /opt/cprocsp/lib/amd64/libnpcades.so.2.0.0
                        ./libnpcades.so
                        <br />
                        ldd libnpcades.so
                        <br />
                        <br />
                        ldconfig
                    </strong>
                </pre>

                <p>
                    <i>
                        Перезапустите Firefox, и убедитесь в наличии CryptoPRO
                        Cades plugin (см. Menu -&gt; Addons).
                    </i>
                </p>
            </div>
        </div>
    );
};
